import React, { useEffect, useState } from "react";
import {
  Button,
  makeStyles,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Switch,
} from "@material-ui/core";
import documentService from "../services/documentService";
import {
  getOptionalConsentCookieValue,
  setOptionalConsentCookie,
} from "../utils/cookieUtils";
import { useDispatch, useSelector } from "react-redux";
import {
  setCookieJarOpen,
  setCookieJarStep,
} from "../redux/actions/cookieActions";
import { RootState } from "../redux/store";
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
   DialogContentText: {
    color: '#48464A',           
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    display: 'inline',
    marginBottom: '15px',
        },

  policyText: {
    textDecoration: "underline",
    cursor: "pointer",
    color: theme.palette.secondary.main,
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '20px',
    fontFamily: 'Inter, sans-serif',
    padding: '10px 20px',
  },
  wideButton: {
    flex: 1,
   color: theme.palette.primary.dark,
   
  },
  dialogActions: {
    flexWrap: "wrap",
    padding: '10px 20px',
    width: '100%',
  },
   
  option: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dialog: {
    maxWidth: '480px',
    padding: '10px',   
  },
  buttonContainer: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(2),
  },
  dialogTitle: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: '20px',
    fontFamily: 'Inter, sans-serif',
    padding: 0,
  },
  dialogContent: {
    padding: '10px 20px',
  },
  subTitle: { 
    color: '#12054D',
    fontWeight: 700,
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
  }
}));

const DialogTitleText = () => {
  const theme = useTheme();
  return (
    <Typography style={{
      color: theme.palette.primary.main,
      fontWeight: 600,
      fontSize: '20px',
      fontFamily: 'Inter, sans-serif',
    }}>
      Cookies
    </Typography>
  );
};

const ManageDialogTitleText = () => {
  const theme = useTheme();
  return (
    <Typography style={{
      color: theme.palette.primary.main,
      fontWeight: 600,
      fontSize: '20px',
      fontFamily: 'Inter, sans-serif',
    }}>
      Manage Cookies
    </Typography>
  );
};

const CookieJar = () => {
    const [optionalConsent, setOptionalConsent] = useState(() => {
        const cookieValue = getOptionalConsentCookieValue();
        return cookieValue === "true";
    });
    const [optionalChecked, setOptionalChecked] = useState(() => {
        const cookieValue = getOptionalConsentCookieValue();
        return cookieValue === "true";
    });
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isOpen: open, step } = useSelector(
    (state: RootState) => state.cookie
  );

  const handleOpenCookiePolicy = async () => {
    window.open(`${process.env.REACT_APP_PLATFORM_URL}/trust-centre/cookie-notice`, '_blank');
  };

  const handleAcceptAll = () => {
    setOptionalConsentCookie("true");

    if (optionalConsent) {
      dispatch(setCookieJarOpen({ isOpen: false }));
      return;
    }

      window.location.reload();
    };

    const handleDeclineNonEssential = () => {
        setOptionalConsentCookie("false");
        if (!optionalConsent) {
            dispatch(setCookieJarOpen({ isOpen: false }));
            return;
        }
    }

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    dispatch(setCookieJarOpen({ isOpen: false }));
  };

  const handleSaveAndClose = () => {
    setOptionalConsentCookie(optionalChecked.toString());

    if (optionalChecked === optionalConsent) {
      dispatch(setCookieJarOpen({ isOpen: false }));
      return;
    }

      window.location.reload();
  };

  useEffect(() => {
    const currentOptionalConsent = getOptionalConsentCookieValue();

    if (currentOptionalConsent === null) {
      dispatch(setCookieJarOpen({ isOpen: true }));
      return;
    }

    setOptionalConsent(currentOptionalConsent === "true");
    setOptionalChecked(currentOptionalConsent === "true");
  }, [open]);

    const handleManageCookiePolicy = () => {
        dispatch(setCookieJarStep({ step: "manage" }))
    }

  const InfoMessage = () => (
    <DialogContentText>
      We use cookies to improve your experience on our website. Read the{" "}
      <span className={classes.policyText} onClick={handleOpenCookiePolicy}>
        WorkNest Cookie Notice
      </span>{" "}
          to find out more or click here to {" "}
          <span className={classes.policyText} onClick={handleManageCookiePolicy}>
              Manage all cookies
          </span>{" "}.
    </DialogContentText>
  );

  const ManageInfoMessage = () => (
    <DialogContentText>
      We use cookies to improve your experience on our website. Read the{" "}
      <span className={classes.policyText} onClick={handleOpenCookiePolicy}>
        WorkNest Cookie Notice
      </span>{" "}
          to find out more.
    </DialogContentText>
  );

  return (
    <Dialog open={open} onClose={handleClose} classes={{ paper: classes.dialog }}>
      {step === "initial" && (
        <>
          <DialogTitle className={ classes.title }>
            <DialogTitleText />
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <InfoMessage />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>        
            <Button
              className={classes.wideButton}
              style={{ backgroundColor: '#5E48CA', color: '#ffffff' }}
              variant="contained"
              onClick={handleAcceptAll}
            >
              Accept All
            </Button>
            <Button
                className={classes.wideButton}
                style={{ backgroundColor: '#5E48CA', color: '#ffffff' }}
                variant="outlined"
                onClick={handleDeclineNonEssential}>
                Decline Non-essential
            </Button>
          </DialogActions>
        </>
      )}
      {step === "manage" && (
        <>
        <DialogTitle className={ classes.title }>
          <ManageDialogTitleText />
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <ManageInfoMessage />
            <Typography variant="h6" className={classes.subTitle}>
              Essential Cookies
            </Typography>
            <div
              className={classes.option}            
            >
              <div className={classes.DialogContentText}>
                ARRAffinity / ARRAffinitySameSite, UserDetails, WorkNest Tokens, Auth0
              </div>
              <Switch checked disabled />
            </div>
            <Typography variant="h6" className={classes.subTitle}>
              Non-essential Cookies
            </Typography>
            <div className={classes.option}           
            >
              <div className={classes.DialogContentText}>
                Optional tracking
              </div>
              <Switch
                checked={optionalChecked}
                onChange={(e: any) => setOptionalChecked(e.target.checked)}
                color="secondary"
              />
            </div>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button                
                color="secondary"
                variant="outlined"
                onClick={handleSaveAndClose}
              >
                Save & Close
              </Button>
              <Button               
                color="secondary"
                variant="contained"
                onClick={handleAcceptAll}
              >
                Accept All
              </Button>
            </div>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default CookieJar;
